import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction, handleActions } from 'redux-actions';
import { defaultGridData } from '../../../module/component/TableBoxModule';
import { PATH_DELIMITER, SUBJECT_SEARCH_BODY_PATH } from '../../../constant/Constant';
import NullCheckUtil from '../../../util/NullCheckUtil';
import { request } from '../../ApiModule';
import { SET_GRID_DATA } from '../../component/TableBoxModule';
import { List } from '@material-ui/core';

const ACTION_SEARCH = SUBJECT_SEARCH_BODY_PATH + PATH_DELIMITER + 'ACTION_SEARCH';
const ACTION_ADD = SUBJECT_SEARCH_BODY_PATH + PATH_DELIMITER + 'ACTION_ADD';
const ACTION_EDIT = SUBJECT_SEARCH_BODY_PATH + PATH_DELIMITER + 'ACTION_EDIT';
const ACTION_REMOVE = SUBJECT_SEARCH_BODY_PATH + PATH_DELIMITER + 'ACTION_REMOVE';
const ACTION_CURRENT_SEMESTER = SUBJECT_SEARCH_BODY_PATH + PATH_DELIMITER + 'ACTION_CURRENT_SEMESTER';
const ACTION_SEARCH_DETAIL = SUBJECT_SEARCH_BODY_PATH + PATH_DELIMITER + 'ACTION_SEARCH_DETAIL';

export const actionSearch = createAction(ACTION_SEARCH);
export const actionAdd = createAction(ACTION_ADD);
export const actionEdit = createAction(ACTION_EDIT);
export const actionRemove = createAction(ACTION_REMOVE);
export const actionCurrentSemester = createAction(ACTION_CURRENT_SEMESTER);
export const actionSearchDetail = createAction(ACTION_SEARCH_DETAIL);

export function* systemTermSagas() {
    yield takeEvery(ACTION_SEARCH, actionSearchSaga);
    yield takeEvery(ACTION_ADD, actionAddSaga);
    yield takeEvery(ACTION_EDIT, actionEditSaga);
    yield takeEvery(ACTION_REMOVE, actionRemoveSaga);
    yield takeEvery(ACTION_CURRENT_SEMESTER, actionCurrentSemesterSaga);
    yield takeEvery(ACTION_SEARCH_DETAIL, actionSearchDetailSaga);
}

function* actionSearchSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'get',
        url: '/api/semesters',
        params,
        callback,
    });
    if (NullCheckUtil.isNotNull(result)) {
        yield put({
            type: SET_GRID_DATA,
            payload: result,
        });
    }
}
function* actionAddSaga({ payload: { data, callback } }) {
    const result = yield call(request, {
        method: 'post',
        url: '/api/semesters',
        data,
        callback,
    });
}
function* actionEditSaga({ payload: { data, callback } }) {
    const result = yield call(request, {
        method: 'put',
        url: `/api/semesters/${data.semesterId}`,
        data,
        callback,
    });
}
function* actionRemoveSaga({ payload: { data, callback } }) {
    const result = yield call(request, {
        method: 'delete',
        url: `/api/semesters/${data.semesterId}`,
        callback,
    });
}
function* actionCurrentSemesterSaga({ payload: { data, callback } }) {
    const result = yield call(request, {
        method: 'post',
        url: '/api/com-prop/keys/CURRENT_SEMESTER',
        data,
        callback,
    });
}
function* actionSearchDetailSaga({ payload: { semesterId, callback } }) {
    const result = yield call(request, {
        method: 'get',
        url: `/api/semesters/${semesterId}/university-detail`,
        params: { semesterId },
        callback,
    });
    if (NullCheckUtil.isNotNull(result)) {
        yield put({
            type: List,
            payload: result,
        });
    }
}
